import {
  Automations,
  PlaybookAlert,
  Users,
} from '@sweep-io/sweep-design/dist/icons';
import { IconProps } from '@sweep-io/sweep-design/dist/icons/common';
import AutomationsVerticalImage from './images/automationsVertical.svg?react';
import AutomationsVerticalWideImage from './images/automationsVerticalWide.svg?react';
import AlertsVerticalImage from './images/alertsVertical.svg?react';
import AlertsVerticalWideImage from './images/alertsVerticalWide.svg?react';
import RoutingVerticalWideImage from './images/routingVerticalWide.svg?react';
import DependenciesVerticalImage from './images/dependenciesVertical.svg?react';
import { AutomationFormVariant } from '../../../../types/enums/AutomationFormVariant';
import { ActionPaywallSource, ActionPaywallItemData } from '../paywallTypes';

//used in Funnel Editor, to show paywall block on the automations dialogs
export const getPaywallSourceFromAutomationVariant = (variant: AutomationFormVariant) => {
  switch (variant) {
    case AutomationFormVariant.AUTOMATIONS:
      return ActionPaywallSource.AUTOMATIONS;
    case AutomationFormVariant.PLAYBOOK_ALERT:
      return ActionPaywallSource.ALERTS;
    case AutomationFormVariant.ASSIGNMENT_RULES:
      return ActionPaywallSource.ASSIGNMENT_RULES;
    default:
      return undefined;
  }
};

export const getActionPaywallBlockData = (source?: ActionPaywallSource): ActionPaywallItemData | undefined => {
  if (!source) {
    return undefined;
  }
  switch (source) {
    case ActionPaywallSource.AUTOMATIONS:
      return {
        Icon: (props) => <Automations {...props} />,
        header: 'Build custom Salesforce automations in minutes',
        subHeader:
          'Create no-code, native Salesforce automations that simplify processes across your team. Contact a Sweep expert to activate your trial.',
        cta: 'Talk to us',
        imageVertical: <AutomationsVerticalImage />,
        imageVerticalWide: <AutomationsVerticalWideImage />,
      };
    case ActionPaywallSource.ALERTS:
      return {
        Icon: (props: IconProps) => <PlaybookAlert {...props} />,
        header: 'Activate your team with custom Salesforce alerts',
        subHeader:
          'Send actionable notifications in Slack or Teams powered by real-time Salesforce data. Contact a Sweep expert to activate your trial.',
        cta: 'Talk to us',
        imageVertical: <AlertsVerticalImage />,
        imageVerticalWide: <AlertsVerticalWideImage />,
      };
    case ActionPaywallSource.ASSIGNMENT_RULES:
      return {
        Icon: (props: IconProps) => <Users {...props} />,
        header: 'Speed up your pipeline with lead routing that works',
        subHeader:
          'Easily create and manage groups, territories and assignment rules for any Salesforce object. Contact a Sweep expert to activate your trial.',
        cta: 'Talk to us',
        imageVerticalWide: <RoutingVerticalWideImage />,
      };
    case ActionPaywallSource.DEPENDENCIES:
      return {
        header: `See what's been built in Salesforce, instantly.`,
        subHeader: (
          <>
            Our visual workspace creates a custom map of your configuration - including custom
            objects! - that you can keep on hand, all the time. <br />
            <br />
            Contact a Sweep team member to activate your free trial.
          </>
        ),
        cta: 'Talk to us',
        imageVertical: <DependenciesVerticalImage />,
      };
    default:
      return undefined;
  }
};
